// extracted by mini-css-extract-plugin
export default {"what":"What_what__a1bMR","title":"What_title__g-RDj","body":"What_body__bIk5b"};